import api from "./Api";

class ContaService {
  GetConta(payload) {
    return api.get("/v1/conta/" + payload).then((response) => {
      return response.data;
    });
  }

  GetAllConta() {
    return api.get("/v1/conta").then((response) => {
      return response.data;
    });
  }

  PostConta(payload) {
    return api.post("/v1/conta/", payload).then((response) => {
      return response.data;
    });
  }

  PutConta(payload) {
    return api.put("/v1/conta/", payload).then((response) => {
      return response.data;
    });
  }

  DeleteConta(payload) {
    return api.delete("/v1/conta/" + payload).then((response) => {
      return response.data;
    });
  }

  GetContaOData(payload) {
    return api.get("/OData/Conta" + payload).then((response) => {
      return response.data;
    });
  }
}

export default new ContaService();
